import {Model} from './Model';

export class SimulationSession {
  public litrage = '';
  public model: Model = {conso: '', consoTrad: '', id: '', img: '', litrage: '', name: '', price: '', subname: '',
    description_fr: '',
    description_nl: ''};
  public priceTrad = 500;
  public priceAriston = 0;
  public priceTradWithoutInstallation = 0;
  public priceAristonWithoutInstallation = 0;
  public priceTradWithInstallation = 0;
  public priceAristonWithInstallation = 0;
  public tva: number| undefined;
  public bonus = 0;
  public calculateWithInstallation = true;
  public priceInstallationTrad: number| undefined;
  public priceInstallationAriston: number| undefined;
  public electricityPrice = 0;
  public amortizationDifferenceY = '';
  public amortizationDifferenceM = '';
  public returnOnInvestments = '';
  public yearlySavings = '';

  // TODO remove test data
  /* public litrage = '200L';
  public model: Model = {id: '10',
    name: 'Nuos Split Inverter WiFi',
    img: 'nuos_plus_wifi.jpg',
    price: '2515',
    conso: '687',
    consoTrad: '2747',
    subname: 'Thermodynamique',
    litrage: '200'};
  public priceTradWithoutInstallation = '606.00';
  public priceAristonWithoutInstallation = '2401.85';
  public priceTradWithInstallation = '2437.00';
  public priceAristonWithInstallation = '5426.85';
  public tva = '6';
  public bonus = '0';
  public priceInstallationTrad = '0';
  public priceInstallationAriston = '0';
  public calculateWithInstallation = true;
  public electricityPrice = 0.25;
  public amortizationDifference = '';
  public returnOnInvestments = '';
  public yearlySavings = ''; */

  constructor() {

  }
}
